// src/pages/Galeria.jsx
import React from "react";
import galeriaImg1 from "../assets/comida.jpg";
import galeriaImg2 from "../assets/cursos.jpg";

function Galeria() {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1>Galería de Imágenes</h1>
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "20px"
      }}>
        <img
          src={galeriaImg1}
          alt="comida"
          style={{ width: "300px", height: "auto" }}
        />
        <img
          src={galeriaImg2}
          alt="personal"
          style={{ width: "300px", height: "auto" }}
        />
        {/* Agrega más imágenes según tu preferencia */}
      </div>
    </div>
  );
}

export default Galeria;
